import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
  RegisterCloseButton,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";
import { useApolloClient } from "@apollo/client";
import { MUTATION_ACKNOWLEDGE_REFUND } from "../graphql/mutations";

export const OverspandingLimitDialog = ({ player, skin }) => {
  const { t } = useTranslation();
  const apolloClient = useApolloClient();

  const acknowledgeRefund = async () => {
    const { data } = await apolloClient.mutate({
      mutation: MUTATION_ACKNOWLEDGE_REFUND,
      variables: {
        nickName: player.nickName,
      },
    });
    if (data) {
      console.log("Acknowledged refund");
      window.location.reload();
    }
    return true;
  };

  const handleAcknowledgement = () => {
    acknowledgeRefund();
  };

  return (
    <StyledModal
      isOpen={player.refundAckRequested && player.refundAckRequested}
    >
      <StyledModalBody
        register
        dangerouslySetInnerHTML={{ __html: t("label_overspending_limit") }}
      ></StyledModalBody>
      <StyledModalFooter position>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={handleAcknowledgement}
        >
          {t("label_ok")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
